<button class="container diamond-shape" [ngClass]="{ selected: isSelected }" (click)="reminderDay.emit(day)">
  <span class="day">{{ dateTimeUtil.weekDaysData[day]?.shortName }}</span>
</button>
